'use client';

import styles from './SelectedEntity.module.css';
import { FC, useState, useContext } from 'react';
import { Flex, Icon, Text } from '@/_components';
import { OtherEntitySelector } from './_components/OtherEntitySelector';
import { CompanyContext } from '@/_contexts/admin/CompanyProvider';
import type { SelectedEntityProps } from './SelectedEntity.types';

export const SelectedEntity: FC<SelectedEntityProps> = ({ company }) => {
  const { selectedCompanyRelatedCompanies } = useContext(CompanyContext);
  const [isRelatedVisible, setRelatedVisible] = useState<boolean>(false);

  const onToggleRelated = () => setRelatedVisible(!isRelatedVisible);
  const onCloseRelated = () => setRelatedVisible(false);

  if (!company?.id) return null;

  return (
    <Flex
      isColumn={true}
      className={styles.selectedEntityContainer}
      onMouseLeave={onCloseRelated}
    >
      <Flex
        isColumn={true}
        gap={2}
        className={styles.selectedEntity}
        onClick={onToggleRelated}
      >
        <Flex isYCentered={true} gap={4}>
          <Text
            type="tiny"
            color="secondary"
            className={styles.selectedEntity__header}
          >
            Entity
          </Text>
        </Flex>
        <Flex isYCentered={true} gap={2}>
          <Text type="small" fontWeight="medium" color="accent">
            {company?.name}
          </Text>
          <Icon name="caret-down" size={16} color="accent" />
        </Flex>
      </Flex>
      <OtherEntitySelector
        company={company}
        isVisible={isRelatedVisible}
        relatedCompanies={selectedCompanyRelatedCompanies}
      />
    </Flex>
  );
};
